import { UseAxiosPaginatedLoaderResult, useAxiosPaginatedLoader } from 'shared/hooks/useAxiosPaginatedLoader';
import { PaginatedResult } from 'shared/types';
import { ShoppingListDto } from './types';

/**
 * useShoppingLists hook result object
 */
interface UseShoppingListsResult
	extends UseAxiosPaginatedLoaderResult<ShoppingListDto, PaginatedResult<ShoppingListDto>> {}

interface UseShoppingListsParams {
	initialPageSize?: number;
}

/**
 * Custom hook for my account Shopping Lists
 */
export function useShoppingListLoader({ initialPageSize }: UseShoppingListsParams): UseShoppingListsResult {
	const {
		page,
		goToPage,
		goToNextPage,
		goToPreviousPage,
		setSorting,
		setPageSize,
		error,
		loading,
		results,
		sortByName,
		sortDirection,
	} = useAxiosPaginatedLoader<ShoppingListDto, PaginatedResult<ShoppingListDto>>({
		axiosParams: {
			url: `/ajax/shopping-lists`,
		},
		initialPageSize: initialPageSize || 20,
	});

	return {
		page,
		goToPage,
		goToNextPage,
		goToPreviousPage,
		setSorting,
		setPageSize,
		error,
		loading,
		results,
		sortByName,
		sortDirection,
	};
}
